import React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import PageContent from "./content";

const Home = () => {
	return (
		<>
			<div className="page-wrapper">
				<Header />
				<PageContent />
				<Footer />
			</div>
		</>
	);
};
export default Home;
